export default function slice_in_weeks(array) {
  var results = []
  for (let i = 0; i < array.length; i += 7) {
    results.push(array.slice(i, i + 7));
  };
  return results;
};